module.exports = __webpack_public_path__ + "static/media/mo.e063c088.svg";